"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/payment-stock.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Fpayment-stock.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.StockPaymentContextRequest = exports.StockPaymentContextCustomerAccountTransfer = exports.StockPaymentContextInterestAdjustment = exports.StockPaymentContextOrderAdjustment = exports.StockPaymentContextCorporateAction = exports.StockPaymentContextOrderAssociation = exports.StockPaymentContext = void 0;
const financial_instrument_1 = require("../common/financial-instrument");
const stock_corporate_action_1 = require("../common/stock-corporate-action");
const stock_order_1 = require("../common/stock-order");
const trading_authorization_1 = require("../common/trading-authorization");
const protobufPackage = 'com.step.common.proto';
function createBaseStockPaymentContext() {
    return {
        symbol: '',
        orderAssociation: undefined,
        corporateAction: undefined,
        orderAdjustment: undefined,
        interestAdjustment: undefined,
        customerAccountTransfer: undefined,
    };
}
exports.StockPaymentContext = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.symbol)) {
            message.symbol = globalThis.String(object.symbol);
        }
        if (isSet(object.orderAssociation)) {
            message.orderAssociation = exports.StockPaymentContextOrderAssociation.fromJSON(object.orderAssociation);
        }
        if (isSet(object.corporateAction)) {
            message.corporateAction = exports.StockPaymentContextCorporateAction.fromJSON(object.corporateAction);
        }
        if (isSet(object.orderAdjustment)) {
            message.orderAdjustment = exports.StockPaymentContextOrderAdjustment.fromJSON(object.orderAdjustment);
        }
        if (isSet(object.interestAdjustment)) {
            message.interestAdjustment = exports.StockPaymentContextInterestAdjustment.fromJSON(object.interestAdjustment);
        }
        if (isSet(object.customerAccountTransfer)) {
            message.customerAccountTransfer = exports.StockPaymentContextCustomerAccountTransfer.fromJSON(object.customerAccountTransfer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.symbol !== undefined && message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        if (message.orderAssociation !== undefined) {
            obj.orderAssociation = exports.StockPaymentContextOrderAssociation.toJSON(message.orderAssociation);
        }
        if (message.corporateAction !== undefined) {
            obj.corporateAction = exports.StockPaymentContextCorporateAction.toJSON(message.corporateAction);
        }
        if (message.orderAdjustment !== undefined) {
            obj.orderAdjustment = exports.StockPaymentContextOrderAdjustment.toJSON(message.orderAdjustment);
        }
        if (message.interestAdjustment !== undefined) {
            obj.interestAdjustment = exports.StockPaymentContextInterestAdjustment.toJSON(message.interestAdjustment);
        }
        if (message.customerAccountTransfer !== undefined) {
            obj.customerAccountTransfer = exports.StockPaymentContextCustomerAccountTransfer.toJSON(message.customerAccountTransfer);
        }
        return obj;
    },
    create(base) {
        return exports.StockPaymentContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStockPaymentContext();
        message.symbol = object.symbol ?? '';
        message.orderAssociation =
            (object.orderAssociation !== undefined && object.orderAssociation !== null)
                ? exports.StockPaymentContextOrderAssociation.fromPartial(object.orderAssociation)
                : undefined;
        message.corporateAction =
            (object.corporateAction !== undefined && object.corporateAction !== null)
                ? exports.StockPaymentContextCorporateAction.fromPartial(object.corporateAction)
                : undefined;
        message.orderAdjustment =
            (object.orderAdjustment !== undefined && object.orderAdjustment !== null)
                ? exports.StockPaymentContextOrderAdjustment.fromPartial(object.orderAdjustment)
                : undefined;
        message.interestAdjustment =
            (object.interestAdjustment !== undefined && object.interestAdjustment !== null)
                ? exports.StockPaymentContextInterestAdjustment.fromPartial(object.interestAdjustment)
                : undefined;
        message.customerAccountTransfer =
            (object.customerAccountTransfer !== undefined && object.customerAccountTransfer !== null)
                ? exports.StockPaymentContextCustomerAccountTransfer.fromPartial(object.customerAccountTransfer)
                : undefined;
        return message;
    },
};
function createBaseStockPaymentContextOrderAssociation() {
    return {
        request: undefined,
        orderHandle: undefined,
        order: undefined,
        symbol: '',
        createdBy: undefined,
        canceledBy: undefined,
        isPlatformOrder: false,
        isRoundUp: false,
        instrument: undefined,
    };
}
exports.StockPaymentContextOrderAssociation = {
    fromJSON(object) {
        const message = {
            symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
        };
        if (isSet(object.request)) {
            message.request = exports.StockPaymentContextRequest.fromJSON(object.request);
        }
        if (isSet(object.orderHandle)) {
            message.orderHandle = stock_order_1.OrderHandle.fromJSON(object.orderHandle);
        }
        if (isSet(object.order)) {
            message.order = stock_order_1.Order.fromJSON(object.order);
        }
        if (isSet(object.createdBy)) {
            message.createdBy = trading_authorization_1.TradingAuthorization.fromJSON(object.createdBy);
        }
        if (isSet(object.canceledBy)) {
            message.canceledBy = trading_authorization_1.TradingAuthorization.fromJSON(object.canceledBy);
        }
        if (isSet(object.isPlatformOrder)) {
            message.isPlatformOrder = globalThis.Boolean(object.isPlatformOrder);
        }
        if (isSet(object.isRoundUp)) {
            message.isRoundUp = globalThis.Boolean(object.isRoundUp);
        }
        if (isSet(object.instrument)) {
            message.instrument = financial_instrument_1.FinancialInstrument.fromJSON(object.instrument);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.request !== undefined) {
            obj.request = exports.StockPaymentContextRequest.toJSON(message.request);
        }
        if (message.orderHandle !== undefined) {
            obj.orderHandle = stock_order_1.OrderHandle.toJSON(message.orderHandle);
        }
        if (message.order !== undefined) {
            obj.order = stock_order_1.Order.toJSON(message.order);
        }
        if (message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        if (message.createdBy !== undefined) {
            obj.createdBy = trading_authorization_1.TradingAuthorization.toJSON(message.createdBy);
        }
        if (message.canceledBy !== undefined) {
            obj.canceledBy = trading_authorization_1.TradingAuthorization.toJSON(message.canceledBy);
        }
        if (message.isPlatformOrder !== undefined && message.isPlatformOrder !== false) {
            obj.isPlatformOrder = message.isPlatformOrder;
        }
        if (message.isRoundUp !== undefined && message.isRoundUp !== false) {
            obj.isRoundUp = message.isRoundUp;
        }
        if (message.instrument !== undefined) {
            obj.instrument = financial_instrument_1.FinancialInstrument.toJSON(message.instrument);
        }
        return obj;
    },
    create(base) {
        return exports.StockPaymentContextOrderAssociation.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStockPaymentContextOrderAssociation();
        message.request = (object.request !== undefined && object.request !== null)
            ? exports.StockPaymentContextRequest.fromPartial(object.request)
            : undefined;
        message.orderHandle = (object.orderHandle !== undefined && object.orderHandle !== null)
            ? stock_order_1.OrderHandle.fromPartial(object.orderHandle)
            : undefined;
        message.order = (object.order !== undefined && object.order !== null)
            ? stock_order_1.Order.fromPartial(object.order)
            : undefined;
        message.symbol = object.symbol ?? '';
        message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
            ? trading_authorization_1.TradingAuthorization.fromPartial(object.createdBy)
            : undefined;
        message.canceledBy = (object.canceledBy !== undefined && object.canceledBy !== null)
            ? trading_authorization_1.TradingAuthorization.fromPartial(object.canceledBy)
            : undefined;
        message.isPlatformOrder = object.isPlatformOrder ?? false;
        message.isRoundUp = object.isRoundUp ?? false;
        message.instrument = (object.instrument !== undefined && object.instrument !== null)
            ? financial_instrument_1.FinancialInstrument.fromPartial(object.instrument)
            : undefined;
        return message;
    },
};
function createBaseStockPaymentContextCorporateAction() {
    return {
        comment: '',
        dividend: undefined,
        dividendTax: undefined,
        mergerAcquisition: undefined,
        symbol: '',
    };
}
exports.StockPaymentContextCorporateAction = {
    fromJSON(object) {
        const message = {
            comment: isSet(object.comment) ? globalThis.String(object.comment) : '',
            symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
        };
        if (isSet(object.dividend)) {
            message.dividend = stock_corporate_action_1.Dividend.fromJSON(object.dividend);
        }
        if (isSet(object.dividendTax)) {
            message.dividendTax = stock_corporate_action_1.DividendTax.fromJSON(object.dividendTax);
        }
        if (isSet(object.mergerAcquisition)) {
            message.mergerAcquisition = stock_corporate_action_1.MergerAcquisition.fromJSON(object.mergerAcquisition);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.comment !== '') {
            obj.comment = message.comment;
        }
        if (message.dividend !== undefined) {
            obj.dividend = stock_corporate_action_1.Dividend.toJSON(message.dividend);
        }
        if (message.dividendTax !== undefined) {
            obj.dividendTax = stock_corporate_action_1.DividendTax.toJSON(message.dividendTax);
        }
        if (message.mergerAcquisition !== undefined) {
            obj.mergerAcquisition = stock_corporate_action_1.MergerAcquisition.toJSON(message.mergerAcquisition);
        }
        if (message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        return obj;
    },
    create(base) {
        return exports.StockPaymentContextCorporateAction.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStockPaymentContextCorporateAction();
        message.comment = object.comment ?? '';
        message.dividend = (object.dividend !== undefined && object.dividend !== null)
            ? stock_corporate_action_1.Dividend.fromPartial(object.dividend)
            : undefined;
        message.dividendTax = (object.dividendTax !== undefined && object.dividendTax !== null)
            ? stock_corporate_action_1.DividendTax.fromPartial(object.dividendTax)
            : undefined;
        message.mergerAcquisition =
            (object.mergerAcquisition !== undefined && object.mergerAcquisition !== null)
                ? stock_corporate_action_1.MergerAcquisition.fromPartial(object.mergerAcquisition)
                : undefined;
        message.symbol = object.symbol ?? '';
        return message;
    },
};
function createBaseStockPaymentContextOrderAdjustment() {
    return { transactionId: '', comment: '', symbol: '', quantity: '' };
}
exports.StockPaymentContextOrderAdjustment = {
    fromJSON(object) {
        const message = {
            transactionId: isSet(object.transactionId) ? globalThis.String(object.transactionId) : '',
            comment: isSet(object.comment) ? globalThis.String(object.comment) : '',
        };
        if (isSet(object.symbol)) {
            message.symbol = globalThis.String(object.symbol);
        }
        if (isSet(object.quantity)) {
            message.quantity = globalThis.String(object.quantity);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transactionId !== '') {
            obj.transactionId = message.transactionId;
        }
        if (message.comment !== '') {
            obj.comment = message.comment;
        }
        if (message.symbol !== undefined && message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        if (message.quantity !== undefined && message.quantity !== '') {
            obj.quantity = message.quantity;
        }
        return obj;
    },
    create(base) {
        return exports.StockPaymentContextOrderAdjustment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStockPaymentContextOrderAdjustment();
        message.transactionId = object.transactionId ?? '';
        message.comment = object.comment ?? '';
        message.symbol = object.symbol ?? '';
        message.quantity = object.quantity ?? '';
        return message;
    },
};
function createBaseStockPaymentContextInterestAdjustment() {
    return { comment: '' };
}
exports.StockPaymentContextInterestAdjustment = {
    fromJSON(object) {
        const message = {
            comment: isSet(object.comment) ? globalThis.String(object.comment) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.comment !== '') {
            obj.comment = message.comment;
        }
        return obj;
    },
    create(base) {
        return exports.StockPaymentContextInterestAdjustment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStockPaymentContextInterestAdjustment();
        message.comment = object.comment ?? '';
        return message;
    },
};
function createBaseStockPaymentContextCustomerAccountTransfer() {
    return {};
}
exports.StockPaymentContextCustomerAccountTransfer = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.StockPaymentContextCustomerAccountTransfer.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseStockPaymentContextCustomerAccountTransfer();
        return message;
    },
};
function createBaseStockPaymentContextRequest() {
    return {};
}
exports.StockPaymentContextRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.StockPaymentContextRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseStockPaymentContextRequest();
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=payment-stock.js.map